import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatDialogModule } from "@angular/material/dialog";
import { MatDividerModule } from "@angular/material/divider";
import { MatTableModule } from "@angular/material/table";
import { MatToolbarModule } from "@angular/material/toolbar";
import { FlexLayoutModule } from "@ngbracket/ngx-layout";
import { AccountsPayableModule } from "@tylertech/accounts-payable-module";
import { ChartJsContainerComponent } from "@tylertech/chart-js";
import { ChartingModule } from "@tylertech/charting-module";
import { CommandsModule } from "@tylertech/commands-module";
import { CommonComponentsModule } from "@tylertech/common-components-module";
import { CommonDialogsModule } from "@tylertech/common-dialogs-module";
import { CoreModule } from "@tylertech/core-module";
import { CustomViewModule } from "@tylertech/custom-view";
import { InfoTableModule } from "@tylertech/info-table-module";
import
{
    LgdCurrencyModule,
    LgdDatePickerModule,
    LgdNumberModule,
    LgdSelectModule,
    LgdTextModule,
    LgdTypeAheadModule
} from "@tylertech/lgd-reactive-forms";
import { MetadataModule } from "@tylertech/metadata-module";
import { ProjectAccountingModule } from "@tylertech/project-accounting-module";
import { PurchasingModule } from "@tylertech/purchasing-module";
import
{
    AddAdjustmentComponent,
    AddAdjustmentDialogComponent,
    AddItemComponent,
    AddItemDialogComponent,
    AddItemMetadataDialogComponent,
    InventoryTransferDialogComponent,
    ItemOrdersChartComponent,
    ItemSummaryComponent,
    ItemSummaryDocumentItemComponent,
    ItemsByClassChartComponent,
    ItemsByProjectChartComponent,
    NewClassDialogComponent,
    NewLocationDialogComponent,
    NewUnitDialogComponent,
    ProjectInventoryComponent,
    ProjectInventoryItemComponent,
    ReceiptDocumentComponent,
    ReceiptDocumentItemComponent,
    TopUsedItemsChartComponent,
    TransactionDialogComponent,
    TransferDocumentComponent,
    TransferDocumentItemComponent,
} from "./components";
import
{
    AccountOffsetLookupService,
    InventoryDialogsService,
    InventoryLocationService,
    InventoryMetadataService,
    InventoryService,
    InventoryUnitService,
    ItemAdjustmentService,
    ItemClassLookupService,
    ItemClassService,
    ItemCommodityCodeLookupService,
    ItemLocationLookupService,
    ItemLocationService,
    ItemLookupService,
    ItemService,
    ItemStatusLookupService,
    ItemUdfService,
    ItemVendorService,
    LocationCodeLookupService,
    ShipToLocationLookupService,
    TransactionCodeLookupService,
    TransactionService,
    UnitLookupService,
    WarehouseLookupService,
} from "./services";

const angularModules = [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule
];
const angularMaterialModules = [
    MatButtonModule,
    MatCardModule,
    MatDialogModule,
    MatDividerModule,
    MatTableModule,
    MatToolbarModule,
];
const lgdModules = [
    CommandsModule,
    CommonComponentsModule,
    CoreModule,
    CustomViewModule
        .withComponents(
            /* eslint-disable @typescript-eslint/naming-convention */
            {
                "inventory-items-by-class-chart": ItemsByClassChartComponent,
                "inventory-items-by-project-chart": ItemsByProjectChartComponent,
                "inventory-top-used-items-chart": TopUsedItemsChartComponent,
                "inventory-item-orders-chart": ItemOrdersChartComponent,
            }
            /* eslint-enable @typescript-eslint/naming-convention */
        ),
    ChartJsContainerComponent,
    ChartingModule,
    CommonDialogsModule,
    InfoTableModule,
    MetadataModule,
    AccountsPayableModule,
    ProjectAccountingModule,
    PurchasingModule,
    LgdDatePickerModule,
    LgdNumberModule,
    LgdCurrencyModule,
    LgdSelectModule,
    LgdTextModule,
    LgdTypeAheadModule,
];

const components = [
    TransferDocumentItemComponent,
    TransferDocumentComponent,
    ReceiptDocumentItemComponent,
    ReceiptDocumentComponent,
    ProjectInventoryItemComponent,
    ProjectInventoryComponent,
    ItemSummaryDocumentItemComponent,
    ItemSummaryComponent,
    ItemOrdersChartComponent,
    TopUsedItemsChartComponent,
    ItemsByProjectChartComponent,
    ItemsByClassChartComponent,
    AddAdjustmentComponent,
    AddItemComponent,
    AddAdjustmentDialogComponent,
    AddItemDialogComponent,
    AddItemMetadataDialogComponent,
    NewClassDialogComponent,
    NewLocationDialogComponent,
    NewUnitDialogComponent,
    InventoryTransferDialogComponent,
    TransactionDialogComponent,
];

@NgModule({
    imports: [
        ...angularModules,
        ...angularMaterialModules,
        ...lgdModules,
    ],
    declarations: components,
    exports: components,
    providers: [
        InventoryDialogsService,
        TransactionCodeLookupService,
        LocationCodeLookupService,
        ItemLookupService,
        InventoryService,
        InventoryMetadataService,
        WarehouseLookupService,
        UnitLookupService,
        TransactionService,
        ShipToLocationLookupService,
        ItemVendorService,
        ItemUdfService,
        ItemStatusLookupService,
        ItemService,
        ItemLocationService,
        ItemLocationLookupService,
        ItemCommodityCodeLookupService,
        ItemClassService,
        ItemClassLookupService,
        ItemAdjustmentService,
        InventoryUnitService,
        InventoryLocationService,
        AccountOffsetLookupService,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class InventoryModule { }
